export default __webpack_public_path__ + "assets/images/371e2022734ddd68209ae8c0bc15d37b.svg";